import { combineReducers } from 'redux';
import SizeEligibilityListGridReducer from 'src/pages/Allocation/SizeEligibilityListGrid/SizeEligibilityListGrid.slice';
import ParameterTogglesReducer, {
  ParameterTogglesSlice,
} from 'src/pages/Allocation/ParameterToggles/ParemeterToggles.slice';
import SankeyGroupedViewReducer from 'src/pages/Allocation/SankeyGroupedView/SankeyGroupedView.slice';

export interface AllocationSlice {
  sizeEligibility: ReturnType<typeof SizeEligibilityListGridReducer>;
  parameterToggles: ParameterTogglesSlice;
  sankeyGroupedView: ReturnType<typeof SankeyGroupedViewReducer>;
}

export default combineReducers({
  sizeEligibility: SizeEligibilityListGridReducer,
  parameterToggles: ParameterTogglesReducer,
  sankeyGroupedView: SankeyGroupedViewReducer,
});
